import _ from 'lodash';
import useApi, { API_METHOD } from '../hooks/use-api';
import { CLUB } from './API';

const useClub = () => {
  const { FetchApi } = useApi();

  const getClubDetail = async (id) => {
    const { status, message, result } = await FetchApi(API_METHOD.GET, `${CLUB}${id}`, null);
    return { status, message, result };
  };

  return { getClubDetail };
};

export default useClub;
